module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('app-instructions'), _vm._v(" "), _c('app-starter')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bcbf04be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Intro.vue
// module id = 54
// module chunks = 0